import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const azureAdAuthGuard: CanActivateFn = (route, state) => inject(MsalGuard).canActivate(route, state);
